{
  "info": "Informācija",
  "negative": "Kļūda",
  "positive": "Izdevās"
}
